<!-- color-selector.component.html -->
<!-- Taustalla himmennetty overlay -->
<div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 animate-fade animate-duration-300 animate-ease-out" (click)="onOverlayClick($event)">
    <!-- Varactual modal-laatikko -->
    <div class="bg-white rounded-lg p-6 w-full max-w-4xl mx-4 flex flex-col relative h-[80vh] overflow-y-auto">

        <div class="shrink-0 mb-4">
        <!-- Ylätunniste: otsikko + sulkunappi -->
        <div class="flex items-center justify-between mb-4">
            <h2 class="text-xl font-bold text-secondary-500">Select color</h2>
            <button class="text-4xl leading-none text-secondary-500 hover:text-secondary-800" (click)="closeModal.emit()">&times;</button>
        </div>

        <!-- HAKU -->
        <div class="mb-4">
            <input
                    type="text"
                    placeholder="Search by RAL code or color name..."
                    class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    (input)="onSearch($event)"
            />
        </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollable-area">

            <!-- 1.Viimeksi käytetyt värit -->
            @if(recentlyUsedColors().length > 0) {
            <h3 class="font-semibold text-xl mb-2 text-slate-700">Viimeksi käytetyt värit</h3>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-12">
                @for (color of recentlyUsedColors(); track color.RAL) {
                    <div
                            class="relative group rounded-lg h-24 cursor-pointer overflow-hidden"
                            [style.background-color]="color.HEX"
                            (click)="onSelectColor(color.RAL)"
                    >
                        <div class="shine-effect"></div>
                        <div class="absolute bottom-1 left-1 right-1 text-center text-sm font-medium drop-shadow"
                             [ngClass]="getTextColor(color.HEX)"
                        >
                            @if(palette() == "RAL"){RAL}  {{ color.RAL }}
                        </div>
                    </div>
                }
            </div>
            }

            <!-- 2. Suosituimmat värit -->
            @if(popularColors().length > 0) {
            <h3 class="font-semibold text-xl mb-2 text-slate-700">Suosituimmat värit</h3>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-12">
                @for (color of popularColors(); track color.RAL) {
                    <div
                            class="relative group rounded-lg h-24 cursor-pointer overflow-hidden border-2 border-primary-200"
                            [style.background-color]="color.HEX"
                            (click)="onSelectColor(color.RAL)"
                    >
                        <div class="shine-effect"></div>
                        <div class="absolute bottom-1 left-1 right-1 text-center text-sm font-medium drop-shadow"
                        [ngClass]="getTextColor(color.HEX)">
                            @if(palette() == "RAL"){RAL}  {{ color.RAL }}
                        </div>
                    </div>
                }

            </div>
            }

        <!-- 3. Muut värit -->
        <h3 class="font-semibold text-xl mb-2 text-slate-700">Muut värit</h3>
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            @for (color of otherColors(); track color.RAL) {
                <div
                        class="relative group rounded-lg h-24 cursor-pointer overflow-hidden border-1 border-slate-100"
                        [style.background-color]="color.HEX"
                        (click)="onSelectColor(color.RAL)"
                >
                    <!-- Shine-elementti (täysin läpinäkyvä div, joka saa animaation hoverilla) -->
                    <div class="shine-effect"></div>

                    <!-- RAL-koodin teksti (valkealla tai tummalla?) -->
                    <div class="absolute bottom-1 left-1 right-1 text-center text-base font-semibold drop-shadow"
                         [ngClass]="getTextColor(color.HEX)"
                    >
                        @if(palette() == "RAL"){RAL} {{ color.RAL }}
                    </div>
                </div>
            }
        </div>
        </div>

    </div>
</div>

